import {Energy} from "./energy.model";

export class Schema {
  constructor(desiredEnergy, comment, prescribedNutrients, days) {
    this._desiredEnergy = desiredEnergy;
    this._comment = comment;
    this._prescribedNutrients = prescribedNutrients;
    this._days = days;
  }

  get desiredEnergy() {
    return this._desiredEnergy;
  }

  set desiredEnergy(amount) {
    this._desiredEnergy = new Energy(amount);
  }

  get prescribedNutrients() {
    return this._prescribedNutrients;
  }

  set prescribedNutrients(prescribedNutrients) {
    this._prescribedNutrients = prescribedNutrients;
  }

  get comment() {
    return this._comment;
  }

  set comment(comment) {
    this._comment = comment;
  }

  get days() {
    return this._days;
  }

  set days(days) {
    this._days = days;
  }

  getFirstDay() {
    return this._days[0];
  }

  getLastDay() {
    return this._days[this._days.length - 1];
  }

  removeDay(dayId) {
    this._days = this._days.filter(d => d.id !== dayId);
  }

  getDay(dayId) {
    return this._days.find(d => d.id === dayId);
  }

  getNextNonEmptyDay(dayId) {
    const dayIndex = this._days.findIndex(day => day.id === dayId);
    return this.getNextNonEmptyDayByIndex(dayIndex + 1);
  }

  getNextNonEmptyDayByIndex(index) {
    if (index > this._days.length - 1) {
      return null;
    }

    const nextDay = this._days[index];

    if (nextDay.isEmpty()) {
      return this.getNextNonEmptyDayByIndex(index + 1);
    }

    return nextDay;
  }

  getPrevNonEmptyDay(dayId) {
    const dayIndex = this._days.findIndex(day => day.id === dayId);
    return this.getPrevNonEmptyDayByIndex(dayIndex - 1);
  }

  getPrevNonEmptyDayByIndex(index) {
    if (index < 0) {
      return null;
    }

    const prevDay = this._days[index];

    if (prevDay.isEmpty()) {
      return this.getPrevNonEmptyDayByIndex(index - 1);
    }

    return prevDay;
  }

  hasComment() {
    return this._comment.length > 0;
  }

  hasComments() {
    if (this.hasComment()) {
      return true;
    }

    let hasComments = false;

    this._days.forEach((day) => {
      if (day.hasComment()) {
        hasComments = true;
      }
      day.plans.forEach((plan) => {
        if (plan.hasComment()) {
          hasComments = true;
        }
      });
    });

    return hasComments;
  }

  toJSON() {
    return {
      desiredEnergy: this.desiredEnergy,
      comment: this.comment,
      prescribedNutrients: this.prescribedNutrients,
      days: this.days,
    };
  }
}
